<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<div class="container-fluid mt-0">
  <div class="row">
    <div class="col-12 flex pt-0 pb-0">
      <div class="col-3" style="padding-right: 0rem;">
        <div class="row m-0 p-0">
          <div class="col-11" id="multiselectDiv">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>

              <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStatuses" optionLabel="label" optionValue="value"
                id="multiselectStatuses" placeholder="Sel. Status" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>

            </div>
          </div>
          <div class="col-1" id="refreshPlatesDiv">
            <button pButton class="refreshPlates" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
          </div>
        </div>
        <div class="flex justify-content-between px-0">
          <span class="m-0 col-7 px-0">Number Of Plates Matching Filter:
            <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</span>
          </span>
          <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
        </div>
      </div>
      <div class="col-9 pb-0">
        <div class="col-12 flex pt-0 pb-0" id="topGroup">
          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4" class="inputBox" placeholder="User ID" readonly />
            </div>
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Plate ID"></button>
              <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="10" (keydown.enter)="searchForPlate()" style="height: 2rem;"  placeholder="Plate ID" />
              <button pButton icon="fa fa-search" class="search-field-blue-end" (click)="searchForPlate()">
              </button>
            </div>
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
              <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10" (keydown.enter)="searchForSample()" class="inputBox" placeholder="Sample ID"/>
              <button pButton icon="fa fa-search" class="search-field-blue-end" (click)="searchForSample()">
              </button>
            </div>
          </div>

          <div class="col-5 topDivspacing pl-0 pr-0" style="text-align: left;">
            <div class="col-12 flex headers">
              <h5>
                Plate :<strong>{{selectedPlate?.lastUpdatedPlateID}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers">
              <h5>
                Status :<strong> {{selectedPlate?.status}}</strong>
              </h5>
            </div>
            <div class="col-12 flex headers">
              <h5>
                Sender :<strong> {{selectedPlate?.sender}}</strong>
              </h5>
            </div>
            <div class="col-12 flex headers">
              <h5>
                Sample Type: <strong> {{selectedPlate?.sampleType}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" *ngIf="selectedPlate?.storagePlate && selectedPlate?.status == 'STORAGE_PLATE'">
              <h5>
                Storage Location: <strong> {{selectedPlate?.storage}} </strong>
              </h5>
            </div>
          </div>

          <div class="col-3 topDivspacing p-0">
            <div class="col-12 flex p-0">
              <button pButton style="position: relative;height: 1%;width: 59%;" label="Download Redo Samples" (click)="downloadRedoSamplesFile()" class="buttonsRound">
                <span class="counter">{{numberOfRedoSamples}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex pt-0 pb-0">
      <div class="col-3 pb-0">
        <div class="tableLHS1">
          <p-table [value]="plates" selectionMode="single" (onRowSelect)="showPlateInfo($event)"
            [(selection)]="tableSelectedRow" [loading]="loading" (onRowUnselect)="clearAllFieldsForNewPlate()">
            <ng-template pTemplate="header">
              <tr style="border: 1px solid lightgray">
                <th class="plate" scope="col">Plate ID <span *ngIf="showDueDate"><br/> (Due Date) </span></th>
                <th class="status" scope="col">Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-plate>
              <tr [pSelectableRow]="plate">
                <td style="border: 1px solid lightgray" class="leftTable" [ngClass]="getPriorityClass(plate?.priority)">
                  <span>{{plate?.lastUpdatedPlateID}}</span>
                  <i *ngIf="plate?.latestUserComment" class="pi pi-comment p-1" [pTooltip]="showLatestComment(plate,datePipe)"></i>
                  <i class="pi pi-star-fill" *ngIf="plate?.reRun"></i>
                  <i class="pi pi-arrow-right-arrow-left p-1" *ngIf="checkStatusChange(plate)"></i>
                  <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span>
                </td>
                <td   style="border: 1px solid lightgray" [ngClass]="getPriorityClass(plate?.priority)">
                  {{plate?.status}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-9 pb-0">
        <table id="batchTable" class="rightTable" aria-describedby="">
          <thead id="batchTableHeader">
            <tr>
              <th class="rightTableHead" scope="col" style="padding: 15px;"></th>
            </tr>
          </thead>
          <tbody id="batchTableBody" style="table-layout: fixed;">
            <tr>
              <td>
                <div class="col-12 flex p-0">
                  <div class="row p-0 m-0">
                    <div class="col-12 flex p-0">
                      <div class="col-3 align-center">
                        <button pButton class="buttonsRound startButton" label="New Plate" (click)="clearAllFieldsForNewPlate()"></button>
                      </div>
                    </div>
                    <div class="col-12 flex p-0">
                      <div class="col-4">
                        <div class="ui-inputgroup labels">
                          <button pButton class="theme-button noHover labelButton" type="button"
                            label="Plate ID"></button>
                          <input pInputText placeholder="Plate ID" [(ngModel)]="selectedPlate.plateID" [disabled]="!disableScanBarcodeInput()" />
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="ui-inputgroup">
                          <button pButton style="font-size: 15px;" class="theme-button noHover labelButton"
                            type="button" label="Project ID"></button>
                          <p-dropdown placeholder="Select Project ID" filter="true" [options]="projectsList" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                            name="projectList" [(ngModel)]="selectedProject" [showClear]="true" [disabled]="!disableScanBarcodeInput()">
                          </p-dropdown>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="ui-inputgroup">
                          <button pButton (click)="showComments()" class="theme-button labelButton" type="button"
                            label="Comment" style="height: 3rem;"></button>
                            <textarea style="height:2.7rem;" placeholder="Enter Comment here" [(ngModel)]="plateComment" [disabled]="!disableScanBarcodeInput()"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 flex p-0">
                      <div class="col-4">
                        <div class="ui-inputgroup labels">
                          <button pButton class="theme-button noHover labelButton" type="button"
                            label="Box-ID"></button>
                          <input pInputText placeholder="Box-ID" [(ngModel)]="selectedPlate.delivery" [disabled]="boxflag"  (keydown.enter)="validateBoxID(selectedPlate.delivery)"/>
                          <button pButton class="theme-button labelButton" icon="fa fa-plus-circle" class="ui-inputgroup popInfoButton"(click)="clearBoxID()"></button>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="ui-inputgroup">
                          <button pButton class="theme-button noHover labelButton" type="button"
                            label="Sample Type"></button>

                            <p-dropdown placeholder="Select Sample-Type" [options]="sampleTypeList" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                            name="senderList" [(ngModel)]="selectedSampleType" [showClear]="true" [disabled] = "disableSampleType"
                            (onChange)="updateSampleforPlate()">
                          </p-dropdown>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="ui-inputgroup labels">
                          <button pButton style="font-size: 15px;" class="theme-button noHover labelButton"
                            type="button" label="Plate Type"></button>
                          <p-dropdown filter="true" optionLabel="label" optionValue="value" [options]="plateTypeOptionList"
                            name="plateTypeOptionList" [(ngModel)]="selectedPlateType" [showClear]="false" [disabled]="!disableScanBarcodeInput()">
                          </p-dropdown>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 flex p-0">
                      <div class="col-5">
                        <div class="ui-inputgroup labels">
                          <button pButton class="theme-button noHover labelButton col-10" type="button" style="height: 3rem;"
                            label="Horizontal Scan"></button>
                            <p-inputSwitch class="col-1" [(ngModel)]="selectedPlate.scanHorizontal" [disabled]="!disableScanHorizontal()"></p-inputSwitch>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 flex p-0">
                      <div class="col-3 align-center">
                        <button pButton class="buttonsRound endButton" [disabled]="disableCreateBatchButton() || disableCreatePlateButton()" (click)="createBatch()" label="Create Plate"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12 flex pt-0 pb-0" style="border: 1px solid #1F89CE; padding-right: 0em; margin-right: 1em;">
      <div class="col-3 pt-0">
        <div class="col-12 flex">
          <input type="text" class="sample-pos" [value]="selectedCell" readonly>
          <input type="password" class="scan-barcode" id="barcode-scanner" placeholder="Scan Barcode"
            [(ngModel)]="scannedBarcode" (keydown.enter)="saveBarcode()" [disabled]="disableScanningOfBarcode()">
        </div>
        <div class="col-12 tableLHS2">
          <p-table [value]="selectedPlateHistory" styleClass="p-datatable-striped" tableStyleClass="samples-table">
            <ng-template pTemplate="header" class="header">
              <tr  style="border: 1px solid lightgray">
                <th class="position" scope="col">Position</th>
                <th class="sample" scope="col">Sample ID</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sample>
              <tr style="border: 1px solid lightgray" (click)="selectSampleFromTable(sample)" (keydown.enter)="selectSampleFromTable(sample)" (keydown.space)="selectSampleFromTable(sample)">
                <td style="border: 1px solid lightgray" style="width: 35%;" class="normalBody pr-0">
                  {{sample?.position}}</td>
                <td style="width: 65%; border: 1px solid lightgray" class="normalBody">
                  <div class="row m-0">
                    <div class="col-11 p-0">{{sample?.sampleId}}</div>
                    <div class="col-1 p-0">
                      <i *ngIf="sample?.approved" class="pi pi-check check"></i>
                      <i *ngIf="!sample?.approved" class="pi pi-times cross"></i>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-9 pt-0" style="padding-right:0px; padding-bottom: 0px;">
        <table id="batchTable" class="rightTable2">
          <tbody id="batchTableBody">
            <table id="scanTable" aria-describedby="View Plates" class="table">
              <thead>
                <tr class="row100 head">
                  <th class="column100 column1" scope="col"></th>
                  <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index">
                    {{col}} </th>
                </tr>
              </thead>
              <tbody>
                <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
                  <td class="column100 column1">{{row}}</td>
                  <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%;">
                    <input class="cellviewsold" [ngClass]="determineClassForDifferentSampleBarcodes(i,j)" pInputText type="text"
                      (click)="selectTableCell(i,j)" [value]="getSampleAt(i, j).sampleID" [pTooltip]="getSampleAt(i, j).sampleID"
                      tooltipPosition="top" readonly />
                  </td>
                </tr>
              </tbody>
            </table>
            <p-footer>
              <div class="row m-0" style="padding: 0% 3%;">
                <div class="col-7 p-0">
                  <button pButton class="buttonsRound removeSamples" label="Remove Sample(s)" (click)="removeSamplesPopup()"
                    [disabled]="disableScanCompleteButton()" style="margin-right: 1rem;"></button>
                  <button pButton class="buttonsRound removeSamples" label="Unsuitable Sample(s)" (click)="showUnsuitableSampleDialog()"
                    [disabled]="disableScanCompleteButton()" style="margin-left:auto;"></button>
                  </div>
                  <div class="col-5 p-0" style="display:flex">
                    <button pButton class="buttonsRound endButton" label="Scan Complete" (click)="checkWellSample()"
                      [disabled]="disableScanCompleteButton()" style="margin-left: auto;"></button>
                </div>
              </div>
            </p-footer>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Sample Check Failed!" [(visible)]="showSampleCheckFailedDialog" [modal]="true" position="top">
  <div class="col-12 sample-check-content">
    <br/>
    <h5> Sample Check failed! </h5>
    <br/>
    <h5> {{ sampleCheckErrorMessage }} </h5>
    <br/>
    <h5> Please set the sample aside. </h5>
    <br/>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Continue" id="add-comment" (click)="closeSampleCheckFailedDialog()"></button>
  </div>
</p-dialog>

<p-dialog header="Remove sample(s)" [style.width]="'350px'"  [(visible)]="removeSamples" [modal]="true" position="top">
  <div class="col-12">
    <table id="scanTable" aria-describedby="View Plates" class="table">
        <tr>
        <th style="display: none"></th>
        </tr>
        <tr>
          <input class="inputWidth" pInputText placeholder="Enter SampleID" name="sampleId" [(ngModel)]="enteredSampleId" id="remove-popup-sampleid" (keydown.enter)="checkSample()"/>
        </tr>
        <tr *ngFor="let sample of sampleList; let myIndex=index;">
          <input pInputText class="inputWidth" name="sampleId" [value]="sample" id="sampleid" readonly />
          <button pButton icon="fa fa-times-circle"class="removePopInput deleteButtonWidth" (click)="deleteValue(myIndex)"></button>
        </tr>
    </table>
    <div>
      <button [disabled]="disableRemoveSamplesButton()" pButton class="buttonsRound removeSamples" label="Remove Sample(s)" (click)="deleteSamples()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Unsuitable Sample" [(visible)]="unsuitableDialog" [modal]="true" position="top" (onHide)="closeUnsuitableDialog()">
  <div class="col-12">
    <table class="table">
      <thead>
        <tr>
          <th class="tableBorder"></th>
          <th class="tableBorder"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="tableBorder white-space-nowrap">
            <p-checkbox (onChange)="onChecked($event)" binary="true" [(ngModel)]="isBarcodeNotReadableChecked"></p-checkbox>
            <span class="ml-1"><strong>Barcode not readable or scannable</strong></span>
          </td>
        </tr>
        <tr class="flex">
          <td class="col-6 borderLessRow"><span><strong>Scan Sample-ID:</strong></span></td>
          <td class="col-6 borderLessRow"><strong>Reason:</strong></td>
        </tr>
        <tr class="flex">
          <td class="col-6 borderLessRow">
            <input pInputText class="form-control" [(ngModel)]="enteredUnsuitableSampleId" [placeholder]="'Sample-ID'" [disabled]="disableSampleInput" style="width: 86%;" (keydown.enter)="addToUnsuitableList()" id="unsuitable-sample-id"/>
          </td>
          <td class="col-6 borderLessRow w-full">
            <p-dropdown [options]="receptionRedoList" [(ngModel)]="selectedRedoReason" [disabled]="disableSampleInput"
            optionLabel="reasonName" optionValue="reasonName" placeholder="Select Reason" (onChange)="onOptionSelected($event)" [filter]="true" filterBy="label" [showClear]="true"></p-dropdown>
          </td>
        </tr>
        <tr *ngFor="let sample of multiUnsuitableSampleList; let i = index;">
          <td>
            <input pInputText name="sampleId"  style="width: 36%;" [value]="sample.barcode" id="sampleId" readonly />
            <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="removeSampleFromList(i)"></button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-12 flex d-flex justify-content-end">
      <button pButton class="buttonsRound removeSamples" label="Mark as Unsuitable" [disabled]="disableUpdateButton" (click)="addUnsuitableSample()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Plate Scan complete" [(visible)]="showPlatePriority" [modal]="true" position="top">
  <div class="col-12 flex">
    <span><strong>Plate {{selectedPlate.plateID}} has priority level {{selectedPlate.priority}}</strong></span>
  </div>

</p-dialog>

<p-dialog header="Please select a sample" showEffect="fade" position="top"
    [(visible)]="duplicateSamplesPresent" [modal]="true"
    [contentStyle]="{'max-height':'70vh'}" (onHide)="resetValues($event)">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View samples" class="table">
        <tbody>
          <tr>
            <th>Sample ID</th>
            <th>SampleType</th>
            <th>Activated</th>
            <th>Gender</th>
            <th>Announced</th>
            <th>Unsuitable (Reason)</th>
            <th>Completed (Date)</th>
            <th></th>
          </tr>
          <tr *ngFor="let sample of allSelectedSamples; let i=index">
            <td>{{ !sample.animalNumber? sample.barCode : sample.animalNumber }}</td>
            <td>{{sample.sampleType}}</td>
            <td>{{sample.activated? "Yes" : "No"}}</td>
            <td>{{sample.gender}}</td>
            <td>{{sample.announcedDate | date: 'dd.MM.yy'}}</td>
            <td>{{sample.receptionStatus === 'REMOVED' ? "Yes (" + sample.receptionIssueReason + ")" : "No" }}</td>
            <td>{{sample.sampleCompletionDate !== null ? ("Yes (" + (sample.sampleCompletionDate | date: 'dd.MM.yy') + ")") : "No"}}</td>
            <td>
              <button [disabled]="checkIfSampleIsDisabledForSelection(sample)" class="removeMargin buttonsRound endButton ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" (click)="selectedSampleFromScan(sample)">Select Sample</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</p-dialog>


<p-dialog header="{{selectedSample.sampleID + ' Comments'}}" [(visible)]="showCommentsDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <div class="col-12 p-0 rounded border border-secondary commentBubble">
    <div class="col-12 flex">
      <div class="col-11 pb-0">
        <label><strong> Sample : </strong>{{selectedSample.sampleID}}</label>
      </div>
      <div class="col-1 pb-0">
        <button *ngIf="commentsDisplayMap.get('showCommentList')" type="button"
          class="float-right btn btn-outline-secondary border-0 p-0"
          (click)="setCommentsDisplay('showCommentList',false)"><em class="fa fa-window-minimize"></em></button>
        <button *ngIf="!commentsDisplayMap.get('showCommentList')" type="button"
          class="float-right btn btn-outline-secondary border-0 p-0"
          (click)="setCommentsDisplay('showCommentList',true)"><em class=" fa fa-window-maximize"></em></button>
      </div>
    </div>

    <div *ngIf="commentsDisplayMap.get('showCommentList')">
      <div *ngFor="let comment of commentList">
        <div class="col-12 p-0 commentBubbleSection">
          <div class="col-12 commentPUIDDate">
            <label>{{comment.puid}} | {{comment.timeStamp | date: 'dd.MM.yy HH:mm'}} | {{comment.status}}</label>
          </div>
          <div class="col-12 commentPUIDDate font-weight-bold">
            <p>{{comment.comment}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="col-12 " id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
      [(ngModel)]="newComment"></textarea>
  </div>
  <div class="col-12 addCommentButton">
    <button style="height: 2rem;" pButton label="Add Comment" [disabled]="!(newComment != null && newComment.trim() != '')"
      (click)="saveComment()"></button>
  </div>
</p-dialog>

<p-dialog header="This Sample is present!" [(visible)]="showSamplePresentDialog" [modal]="true" position="top">
  <div class="col-12 sample-check-content">
    <br/>
    <h5> Sample is present in the manifest! </h5>
    <br/>
    <h5> {{ samplePresentErrorMessage }} </h5>
    <br/>
    <br/>
  </div>
  <div class="col-12 flex" >
    <div class="col-6 mt-2 add-comment-container">
      <button pButton label="Place the Sample" id="add-comment" (click)="placeAnnouncedSampleforStorage()"></button>
    </div>
      <div class="col-6 mt-2 add-comment-container">
      <button pButton label="Set it Aside" id="add-comment" (click)="closeSamplePresentDialog()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Select the StorageLocation!" [(visible)]="showStorageDialog" [modal]="true" position="top">
  <div style="width: 28rem;">
    <br/>
    <h5> Select the Storage Location to store the Plate! </h5>
    <br/>
    <button pButton style="font-size: 16px;width: 11rem; height: 2.4rem;" class="theme-button noHover labelButton" type="button" label="Storage Location"></button>
    <p-dropdown appendTo="body" [(ngModel)]="selectedPlateStorage" filter="true" [options]="storageList"></p-dropdown>
    <br/>
    <br/>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Store" class="buttonsRound startButton" id="add-comment"  (click)="addPlateToStorage()"></button>
  </div>
</p-dialog>

<p-dialog header="Plate not filled up!!" [(visible)]="showPlateNotFilledUpPopup" [modal]="true" position="top" [style]="{width: '50vw'}">
  <div class="col-9">
    <h5>The Plate {{selectedPlate.plateID}} has still empty positions.</h5>
    <br/>
    <h5>Do you want to continue?</h5>
  </div>
  <div class="col-12 flex">
    <div class="col-6 mt-2 add-comment-container">
      <button pButton class="buttonsRound removeSamples" label="Go Back" (click)="goBackCompleteScan()"></button>
    </div>
      <div class="col-6 mt-2">
      <button pButton class="buttonsRound startButton" label="Continue" (click)="updatePlate('RECEPTION_COMPLETED')"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Box Empty?" [(visible)]="boxEmptyPopup" [modal]="true" position="center">
  <div class="col-12 flex">
    <br/>
    <h5>Are there still samples in the Box <span style="color: #1F89CE;">{{selectedPlate.delivery}}</span> ?</h5>
    <br/>
  </div>
  <div class="col-12 flex">
    <div class="col-6 mt-2 add-comment-container">
      <button pButton class="buttonsRound removeSamples" label="Not empty" (click)="updateBoxStatus(selectedPlate.delivery, 'UNBOXED')"></button>
    </div>
      <div class="col-6 mt-2">
      <button pButton class="buttonsRound startButton" label="Box is empty" (click)="updateBoxStatus(selectedPlate.delivery,'COMPLETED')"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="{{selectedPlate.plateID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <app-ma-comments-popup [selectedPlateID]="selectedPlateID" [selectedPlateStatus]="selectedPlateStatus"  [plateCommentList] = "plateCommentsList"  [beadChipCommentsDisplayMap]="beadChipCommentsDisplayMap" [beadChipCommentsMap]="beadChipCommentsMap" [disableInput]="selectedPlate?.status == 'RECEPTION_COMPLETED' || selectedPlate?.processSteps?.length>=1" (backButtonEmitter)="hideDialog()"></app-ma-comments-popup>
</p-dialog>
